var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18099_109343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1595 9.99962C7.16038 10.074 7.14613 10.1477 7.11767 10.2161C7.08922 10.2844 7.04718 10.3459 6.99426 10.3965L2.03719 15.4994C1.81688 15.7262 1.47539 15.7262 1.25508 15.4994C1.03477 15.2726 1.03477 14.921 1.25508 14.6943L5.8266 9.98828L1.26609 5.29364C1.04578 5.06685 1.04578 4.71532 1.26609 4.48852C1.48641 4.26173 1.8279 4.26173 2.04821 4.48852L7.00528 9.59139C7.11543 9.70478 7.17051 9.8522 7.17051 9.98828L7.1595 9.99962Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18099_109343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6966 9.99962C11.6975 10.074 11.6832 10.1477 11.6548 10.2161C11.6263 10.2844 11.5843 10.3459 11.5314 10.3965L6.5743 15.4994C6.35399 15.7262 6.0125 15.7262 5.79219 15.4994C5.57187 15.2726 5.57187 14.921 5.79219 14.6943L10.3637 9.98828L5.8032 5.29364C5.58289 5.06685 5.58289 4.71532 5.8032 4.48852C6.02352 4.26173 6.365 4.26173 6.58532 4.48852L11.5424 9.59139C11.6525 9.70478 11.7076 9.8522 11.7076 9.98828L11.6966 9.99962Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18099_109343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1435,
    height: 7.4968,
    fill: "white",
    transform: "translate(0 19.0718) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18099_109343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1435,
    height: 7.4968,
    fill: "white",
    transform: "translate(4.41113 19.0718) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBtn);
export default __webpack_public_path__ + "static/media/nextBtn.843fc562c525385e908e7433e3950caa.svg";
export { ForwardRef as ReactComponent };